module.exports = __webpack_public_path__ + "static/media/Group8786.04352b3c.png";